module.exports = __webpack_public_path__ + "static/cvrababw.dd4f63fc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/cvrababw.pdf
// module id = 347
// module chunks = 35783957827783